import { groupReducer } from '@/features/admin/groups/groupSlice'
import { roleReducer } from '@/features/admin/roles/roleSlice'
import { userReducer } from '@/features/admin/users/userSlice'
import { customerReducer } from '@/features/internal/customers/customerSlice'
import guideReducer from '@/features/internal/guide/guideSlice'
import { hubServerReducer } from '@/features/internal/hub/hubServerSlice'
import { hubStatusReducer } from '@/features/internal/hub/hubStatusSlice'
import { organizationReducer } from '@/features/organizations/organizationSlice'
import { toursReducer } from '@/features/tours/engine/tours-slice'

import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { baseApi } from './api/base-api'
import { authReducer } from './authSlice'
import { siteHeaderReducer } from './siteHeaderSlice'
import { zoomWidgetReducer } from './zoomWidgetSlice'

export const store = configureStore({
  reducer: {
    // Slice reducers
    auth: authReducer,
    zoomWidget: zoomWidgetReducer,
    siteHeader: siteHeaderReducer,
    organization: organizationReducer,
    group: groupReducer,
    user: userReducer,
    role: roleReducer,
    customer: customerReducer,
    hubServer: hubServerReducer,
    hubStatus: hubStatusReducer,
    guide: guideReducer,
    tours: toursReducer,

    [baseApi.reducerPath]: baseApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 128,
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/REGISTER',
          'api/executeQuery/fulfilled',
          'api/executeQuery/pending',
          'api/executeQuery/rejected'
        ],
        ignoredActionsPaths: [
          'meta.baseQueryMeta.request',
          'meta.baseQueryMeta.response'
        ],
        ignoredPaths: ['register', 'rehydrate', 'api']
      }
    }).concat(baseApi.middleware)
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Wipes every client-side cache when the active organization changes — many
// queries either take no `orgId` arg (one shared cache key across orgs) or
// filter server-side from the session, so per-tag invalidation can't reliably
// swap out stale data.
export function resetAllApiState(dispatch: AppDispatch) {
  dispatch(baseApi.util.resetApiState())
}
